module.exports = __webpack_public_path__ + "media/bootstrap-icons/disc-fill-6ba87477.svg";